<app-left-side></app-left-side>
<app-right-side></app-right-side>
<app-header></app-header>
<br><br><br><br>
<h1 class="text-center"> Coming soon</h1>